import Vue from 'vue';

export default [
  {
    value: '{{mes_anterior_nombre}}',
    label: 'Mes anterior como Nombre',
    example: Vue.moment().subtract(1, 'months').format('MMMM [del] YYYY')
  },
  {
    value: '{{mes_anterior_date}}',
    label: 'Mes anterior como Fecha ',
    example: Vue.moment().subtract(1, 'months').format('MM-DD-YYYY')
  },
  {
    value: '{{mes_anterior}}',
    label: 'Mes anterior como número',
    example: Vue.moment().subtract(1, 'months').format('MM [del] YYYY')
  },
  {
    value: '{{mes_actual_nombre}}',
    label: 'Mes actual como Nombre',
    example: Vue.moment().format('MMMM')
  },
  {
    value: '{{mes_actual_date}}',
    label: 'Mes actual como Fecha ',
    example: Vue.moment().format('MM-DD-YYYY')
  },
  {
    value: '{{mes_actual}}',
    label: 'Mes actual como número',
    example: Vue.moment().format('MM')
  },
  {
    value: '{{detalle.valorMoneda}}',
    label: 'Valor de cambio',
    example: '1000'
  },
  {
    value: '{{cuota}}',
    label: 'Número de cuota actual',
    example: '1'
  },
  {
    value: '{{cuotas}}',
    label: 'Número de cuotas totales',
    example: '10'
  }
];
